export const pageTypeItems = [
  { text: 'Страница', value: 'page' },
  { text: 'Баланс', value: 'balance' },
  { text: 'Платеж', value: 'payment' },
  { text: 'Не авторизован', value: 'unauthorized' },
  { text: 'Руководитель', value: 'supervisor' },
  { text: 'Работник', value: 'employee' },
  { text: 'ЭЦП', value: 'cds' },
  { text: 'ЭЦП Просрочен', value: 'cds_expired' },
  { text: 'День рождения', value: 'birthday' },
  { text: 'Открыть счет', value: 'open_account' },
];

export const categoryItems = [
  { text: 'Продажа', value: 'SALES' },
  { text: 'Сотрудники', value: 'WORKER' },
  { text: 'Регистрация', value: 'REGISTRATION' },
  { text: 'Налоги', value: 'TAX' },
  { text: 'ЭЦП', value: 'DIGITAL_SIGN' },
  { text: 'Баланс', value: 'BALANCE' },
  { text: 'Открыть счет', value: 'OPEN_ACCOUNT' },
];

export const typeItems = {
  SALES: [{ text: 'Пакет', value: 'PACKAGE' }],
  WORKER: [
    { text: 'Добавление работника', value: 'ADD_WORKER' },
    { text: 'День рождение', value: 'BIRTHDAY' },
  ],
  REGISTRATION: [{ text: 'Регистрация', value: 'REGISTRATION' }],
  TAX: [
    { text: 'Оплатить', value: 'PAY' },
    { text: 'Оплачен', value: 'PAID' },
  ],
  DIGITAL_SIGN: [
    { text: 'Добавление электронной подписи', value: 'ADD_DIGITAL_SIGN' },
    { text: 'Просроченный', value: 'OVER_DUE' },
  ],
  BALANCE: [{ text: 'Лимит', value: 'LIMIT' }],
  OPEN_ACCOUNT: [{ text: 'Открытие счета', value: 'OPEN_ACCOUNT' }],
};

export const categoryMap = {
  SALES: 'Продажник',
  WORKER: 'Рабочий',
  REGISTRATION: 'Регистрация',
  TAX: 'Налог',
  DIGITAL_SIGN: 'Электронная подпись',
  BALANCE: 'Баланс',
};

export const typeMap = {
  PACKAGE: 'Пакет',
  ADD_WORKER: 'Добавление работника',
  BIRTHDAY: 'День рождение',
  REGISTRATION: 'Регистрация',
  PAY: 'Оплатить',
  PAID: 'Оплачен',
  ADD_DIGITAL_SIGN: 'Добавление электронной подписи',
  OVER_DUE: 'Просроченный',
  LIMIT: 'Лимит',
};

export const pageTypeMap = {
  page: 'Страница',
  balance: 'Баланс',
  payment: 'Платеж',
  unauthorized: 'Не авторизован',
  supervisor: 'Руководитель',
  employee: 'Работник',
  cds: 'ЭЦП',
  cds_expired: 'ЭЦП Просрочен',
  birthday: 'День рождения',
};
